import { configureStore, createSlice } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import rootSaga from '../_sagas'
import { logger } from 'redux-logger'

const initialState = {
    loading: false,
    verifyModal: null,
    notifModal: null,
    auditAdminModal: null,
    displayModal: null,
    title: null,
    educationList: [],
    employeeList: [],
    servicesList: [],
    locationProofFiles: [],
    experienceProofFiles: [],
    paymentModal: null,
    auditModal: null,
    assuranceModal: null,
    approvalModal: null,
    educationQualCounter: 0,
    employeeQualificationsCounter: 0,
    sectionAData: {
        applicantCategory: "",
        surname: "",
        middleName: "",
        firstName: "",
        tin: "",
        nin: "",
        passport_number: "",
        brn: "",
        entity_registration: "",
        nationality: "Ugandan",
        entity_name: "",
        dateOfIncorporation: "",
        entityType: "", 
        contact_first_name: "",
        contact_last_name: "",
        contact_middle_name: "",
        contact_phone_number: "",
        secondary_contact_phone_number: "",
        applicationPurpose: "", 
        validity: "",
        experience: "",
        trading_name: "",
        district: "",
        county: "",
        subcounty: "",
        parish: "",
        village: "",
        location_proof: "",
        service_type: "",
        specify_service: "",
        website: "",
        annual_turnover: "",
        company_certification: "",
        membership: "",
        specify_membership: "",
        no_males: "",
        no_females: "",
        certification_level: "",
        serviceName: [],
        skillName: [],
        tinVerificationStatus: false,
        taxPayerName: ""
    },
    loadingAuth: false
}

const AppSlice = createSlice( {
    name: "app",
    initialState,
    reducers: {
        setDisplayVerify: ( state, action ) => {
            state.verifyModal = { 
                display: action.payload.flag, 
                id: action.payload.id,
                record: action.payload.record
            }
        },
        setOpenNotificationModal: ( state, action ) =>  {
            state.notifModal = {
                display: action.payload.flag,
                type: action.payload.type
            }
        },
        setAuditAdminModal: ( state, action ) =>  {
            state.auditAdminModal = {
                id: action.payload.id,
                email: action.payload.email,
                display:action.payload.flag
            }
        },
        setQAAModal: ( state, action ) =>  {
            state.assuranceModal = {
                id: action.payload.id,
                email: action.payload.email,
                display:action.payload.flag,
                progress: action.payload.progress
            }
        },
        setApprovalModal: ( state, action ) => {
            state.approvalModal = {
                id: action.payload.id,
                email: action.payload.email,
                display:action.payload.flag,
                progress: action.payload.progress
            }
        },
        setDisplayModal: ( state, action ) => {
            state.displayModal = { 
                flag: action.payload.flag, 
                title: action.payload.title 
            }
        },
        setEducationList: ( state, action ) => {
            state.educationList = action.payload.educationList
        },
        setEmployeeList: ( state, action ) => {
            state.employeeList = action.payload.employeeList
        },
        setServicesList: ( state, action ) => {
            state.servicesList = action.payload.servicesList
        },
        setExperienceProofFiles: ( state, action ) => {
            state.experienceProofFiles = action.payload.experienceProofFiles
        },
        setLocationProofFiles: ( state, action ) => {
            state.locationProofFiles = action.payload.locationProofFiles
        },
        setVerifyModal: ( state, action ) => {
            state.verifyModal = { 
                verifyFlag: action.payload.verifyFlag, 
                title: action.payload.title 
            }
        },
        setPaymentModal: ( state, action ) => {
            state.paymentModal = { 
                paymentFlag: action.payload.paymentFlag, 
                title: action.payload.title 
            }
        },
        setAuditModal: ( state, action ) => {
            state.auditModal = { 
                auditFlag: action.payload.auditFlag, 
                title: action.payload.title 
            }
        },
        setAssuranceModal: ( state, action ) => {
            state.assuranceModal = { 
                assuranceFlag: action.payload.assuranceFlag, 
                title: action.payload.title 
            }
        },
        setApproveModal: ( state, action ) => {
            state.approvalModal = { 
                approvalFlag: action.payload.approvalFlag, 
                title: action.payload.title 
            }
        },
        setEducationQualCounter: (state, action) => {
            state.educationQualCounter += action.payload
        },
        setEmployeeQualificationsCounter: (state, action) => {
            state.employeeQualificationsCounter += action.payload
        },
        setSectionAData: (state, action) => {
            state.sectionAData = { 
                applicantCategory: action.payload.applicantCategory, 
                surname: action.payload.surname,
                middleName: action.payload.middleName,
                firstName: action.payload.firstName,
                tin: action.payload.tin,
                nin: action.payload.nin,
                passport_number: action.payload.passport_number,
                brn: action.payload.brn,
                entity_registration: action.payload.entity_registration,
                nationality: action.payload.nationality,
                entity_name: action.payload.entity_name,
                dateOfIncorporation: action.payload.dateOfIncorporation,
                entityType: action.payload.entityType, 
                contact_first_name: action.payload.contact_first_name,
                contact_last_name: action.payload.contact_last_name,
                contact_middle_name: action.payload.contact_middle_name,
                contact_phone_number: action.payload.contact_phone_number,
                secondary_contact_phone_number: action.payload.secondary_contact_phone_number,
                applicationPurpose: action.payload.entityType, 
                validity: action.payload.validity,
                experience: action.payload.experience,
                trading_name: action.payload.trading_name,
                district: action.payload.district,
                county: action.payload.county,
                subcounty: action.payload.subcounty,
                parish: action.payload.parish,
                village: action.payload.village,
                location_proof: action.payload.location_proof,
                service_type: action.payload.service_type,
                specify_service: action.payload.specify_service,
                website: action.payload.website,
                annual_turnover: action.payload.annual_turnover,
                company_certification: action.payload.company_certification,
                membership: action.payload.membership,
                specify_membership: action.payload.specify_membership,
                no_males: action.payload.no_males,
                no_females: action.payload.no_females,
                certification_level: action.payload.certification_level,
                serviceName: action.payload.serviceName,
                skillName: action.payload.skillName,
                tinVerificationStatus: action.payload.tinVerificationStatus,
                taxPayerName: action.payload.taxPayerName
            }
        },
        setFetchAuth: ( state, action ) => {
            state.loadingAuth = action.payload.flag
        }
    }
} )

export const { 
    setDisplayVerify, 
    setOpenNotificationModal,
    setAuditAdminModal,
    setQAAModal,
    setApprovalModal,
    setDisplayModal,
    setEducationList,
    setEmployeeList,
    setServicesList,
    setExperienceProofFiles,
    setLocationProofFiles,
    setVerifyModal,
    setPaymentModal,
    setAuditModal,
    setAssuranceModal,
    setApproveModal,
    setEducationQualCounter,
    setEmployeeQualificationsCounter,
    setSectionAData,
    setFetchAuth
} = AppSlice.actions

const sagaMiddleware = createSagaMiddleware()

const store  = configureStore( {
    reducer: {
        application: AppSlice.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat( sagaMiddleware, logger )
} )

sagaMiddleware.run( rootSaga )

export default store